
import { createRoot } from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import "./index.css";
import { ConditionalAuthProvider } from "@/contexts/ConditionalAuthProvider";
import { ThemeProvider } from "next-themes";
import { Toaster } from "@/components/ui/toaster";
import { ConditionalTourProvider } from "@/contexts/ConditionalTourProvider";
import { HelmetProvider } from "react-helmet-async";
import { BrandProvider } from "@/contexts/BrandContext";
import BrandPreviewBar from "@/components/brand/BrandPreviewBar";

console.log('🚀 [Main] App initialization starting - Build timestamp:', new Date().toISOString());
console.log('🚀 [Main] Environment check:', {
  mode: import.meta.env.MODE,
  dev: import.meta.env.DEV,
  prod: import.meta.env.PROD
});

const queryClient = new QueryClient();

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <ThemeProvider defaultTheme="light" enableSystem>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <BrandProvider>
        <ConditionalAuthProvider>
          <ConditionalTourProvider>
            <App />
            <BrandPreviewBar />
          </ConditionalTourProvider>
        </ConditionalAuthProvider>
        </BrandProvider>
      </BrowserRouter>
    </QueryClientProvider>
    </ThemeProvider>
  </HelmetProvider>
);

console.log('🚀 [Main] App render called - Ready!');
